var base;

require('core-js/fn/array/find');

require('core-js/fn/array/find-index');

require('core-js/fn/object/keys');

require('core-js/fn/object/entries');

require('core-js/fn/object/assign');

require('core-js/fn/object/values');

require('core-js/fn/string/includes');

require('picturefill');

require('dom4');

document.head || (document.head = document.getElementsByTagName('head')[0]);

(base = window.location).origin || (base.origin = window.location.protocol + "//" + window.location.host);


/*
 * Chrome requestIdleCallback() shim: https://gist.github.com/paullewis/55efe5d6f05434a96c36
 */

window.requestIdleCallback = window.requestIdleCallback || function(cb) {
  return setTimeout((function() {
    var start;
    start = Date.now();
    return cb({
      didTimeout: false,
      timeRemaining: function() {
        return Math.max(0, 50 - (Date.now() - start));
      }
    });
  }), 1);
};


/*
 * Chrome cancelIdleCallback() shim: https://gist.github.com/paullewis/55efe5d6f05434a96c36
 */

window.cancelIdleCallback = window.cancelIdleCallback || function(id) {
  return clearTimeout(id);
};

Array.prototype.move = function(from, to) {
  this.splice(to, 0, this.splice(from, 1)[0]);
  return this;
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvc3JjL2Zyb250ZW5kL2NvcmUvZG9tX2pzX3NoaW0uY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvc3JjL2Zyb250ZW5kL2NvcmUvZG9tX2pzX3NoaW0uY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsT0FBQSxDQUFRLHVCQUFSOztBQUNBLE9BQUEsQ0FBUSw2QkFBUjs7QUFDQSxPQUFBLENBQVEsd0JBQVI7O0FBQ0EsT0FBQSxDQUFRLDJCQUFSOztBQUNBLE9BQUEsQ0FBUSwwQkFBUjs7QUFDQSxPQUFBLENBQVEsMEJBQVI7O0FBQ0EsT0FBQSxDQUFRLDRCQUFSOztBQUNBLE9BQUEsQ0FBUSxhQUFSOztBQUVBLE9BQUEsQ0FBUSxNQUFSOztBQUdBLFFBQVEsQ0FBQyxTQUFULFFBQVEsQ0FBQyxPQUFTLFFBQVEsQ0FBQyxvQkFBVCxDQUE4QixNQUE5QixDQUFzQyxDQUFBLENBQUE7O1FBR3hELE1BQU0sQ0FBQyxTQUFRLENBQUMsZUFBRCxDQUFDLFNBQVcsTUFBTSxDQUFDLFFBQVEsQ0FBQyxRQUFoQixHQUEyQixJQUEzQixHQUFrQyxNQUFNLENBQUMsUUFBUSxDQUFDOzs7QUFHN0U7Ozs7QUFHQSxNQUFNLENBQUMsbUJBQVAsR0FBNkIsTUFBTSxDQUFDLG1CQUFQLElBQThCLFNBQUMsRUFBRDtTQUN6RCxVQUFBLENBQVcsQ0FBQyxTQUFBO0FBQ1YsUUFBQTtJQUFBLEtBQUEsR0FBUSxJQUFJLENBQUMsR0FBTCxDQUFBO1dBQ1IsRUFBQSxDQUNFO01BQUEsVUFBQSxFQUFZLEtBQVo7TUFDQSxhQUFBLEVBQWUsU0FBQTtlQUFHLElBQUksQ0FBQyxHQUFMLENBQVMsQ0FBVCxFQUFZLEVBQUEsR0FBSyxDQUFDLElBQUksQ0FBQyxHQUFMLENBQUEsQ0FBQSxHQUFhLEtBQWQsQ0FBakI7TUFBSCxDQURmO0tBREY7RUFGVSxDQUFELENBQVgsRUFNRyxDQU5IO0FBRHlEOzs7QUFTM0Q7Ozs7QUFHQSxNQUFNLENBQUMsa0JBQVAsR0FBNEIsTUFBTSxDQUFDLGtCQUFQLElBQTZCLFNBQUMsRUFBRDtTQUFRLFlBQUEsQ0FBYSxFQUFiO0FBQVI7O0FBR3pELEtBQUssQ0FBQSxTQUFFLENBQUEsSUFBUCxHQUFjLFNBQUMsSUFBRCxFQUFPLEVBQVA7RUFDWixJQUFJLENBQUMsTUFBTCxDQUFZLEVBQVosRUFBZ0IsQ0FBaEIsRUFBbUIsSUFBSSxDQUFDLE1BQUwsQ0FBWSxJQUFaLEVBQWtCLENBQWxCLENBQXFCLENBQUEsQ0FBQSxDQUF4QztBQUNBLFNBQU87QUFGSyJ9
